import { useState } from "react"
import { TextField } from "@mui/material"
import { setFromEvent } from "lib/setFromEvent"
import { DialogBox } from "lib/@components/dialogBox"

export function NameDialog({ title, value = "", label, placeholder, namesList }) {
    const [name, setName] = useState(value)
    const isNameDublicate = !!(name && namesList?.some((item) => normalizeName(item) === normalizeName(name)))
    const errorMsg = isNameDublicate ? `There is already an item named: '${name}'. Please try again` : ""
    const okDisabled = () => isNameDublicate || !name?.trim()

    return (
        <DialogBox title={title} value={name} okDisabled={okDisabled} beforeOk={(v) => v?.trim()} data-cy="name-dialog">
            <TextField
                sx={{ mt: 2 }}
                autoFocus
                placeholder={placeholder}
                fullWidth
                value={name}
                onChange={setFromEvent(setName)}
                variant="standard"
                label={label}
                data-cy="name-dialog-input"
                error={isNameDublicate}
                helperText={errorMsg}
            />
        </DialogBox>
    )

    function normalizeName(value) {
        return value?.trim()?.toLowerCase()
    }
}
